/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  baseApiUrl = 'https://digitalweek-api.360projectview.com/public/'
 }
else {
  baseApiUrl = 'http://localhost/digitalweek-api/public/'
  // baseApiUrl = 'http://localhost:8000/'

}

export {
  baseApiUrl
}
